import { PriceOverrideScreenType } from './PriceOverrideAuthorityDialog.properties';
import PriceOverrideSchema from './PriceOverrideAuthorityDialog.form';

export const PriceOverrideFormSchemas = {
  [PriceOverrideScreenType.UserAuthAndReasonScreen]: PriceOverrideSchema.UserAuthAndReasonScreen,
  [PriceOverrideScreenType.ReasonScreen]: PriceOverrideSchema.ReasonScreen,
  [PriceOverrideScreenType.UserAuthScreen]: PriceOverrideSchema.UserAuthScreen,
};
